import axios from 'axios';
import { getToken, fetchToken } from './authService';

export const api = axios.create();

api.interceptors.request.use(async config => {
  let token = getToken();

  // Optionally fetch token once if not present
  if (!token) {
    token = await fetchToken(); // make sure this returns a resolved promise
  }
  
  config.headers.Authorization = `Bearer ${token}`;


  return config;
});
